<template>
  <lf-checkbox-dropdown
    v-model="productsRequested"
    show-clear-filter
    no-label-format
    as-badge
    sort
    class="flex-1 flex-col h-6-5"
    :clear-text="$t('COMMON.CLEAR')"
    :placeholder="$t('DEALS.DEAL_PROGRESS.BUSINESS_INFO.PRODUCTS_REQUESTED')"
    :options="offerTemplatesOptions"
    :name="FUNDING_INFO_FIELD_IDS.products_requested"
    :max-items-displayed
    custom-dropdown-class="z-50 max-w-56"
    @update:model-value="handleValueUpdate"
  />
</template>
<script setup lang="ts">
import { computed, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";

import debounce from "lodash/debounce";

import {
  FUNDING_INFO_FIELD_IDS,
  WORKFLOW_BLOCKS_IDS,
} from "@/helpers/constants/workflow";
import { usePromiseWrapper } from "@/hooks/common";
import { useWorkflowFields, useWorkflowOfferTemplate } from "@/hooks/workflow";

import LfCheckboxDropdown from "@/components/ui/inputs/LfCheckboxDropdown.vue";

const { fieldData } = useWorkflowFields(WORKFLOW_BLOCKS_IDS.funding);

const { offerTemplatesOptions } = useWorkflowOfferTemplate();
const { dispatch } = useStore();

const productsRequested = ref<string[]>([]);

const maxItemsDisplayed = computed(
  () => Object.keys(offerTemplatesOptions).length + 1
);

const { fetchWrapper: getWflOfferTemplates } = usePromiseWrapper(() => {
  dispatch("applications/getWorkflowOfferTemplates");
});

const { fetchWrapper: saveUpdatedValues, loading } = usePromiseWrapper(
  debounce(async () => {
    await dispatch("workflows/updateWorkflowSnapshotFields", {
      funding: {
        funding_products_requested: productsRequested.value,
      },
    });
  }, 800)
);

const handleValueUpdate = async (value: unknown) => {
  productsRequested.value = value as string[];
  await saveUpdatedValues();
};

watch(
  fieldData,
  (newVal) => {
    if (loading.value) {
      return;
    }
    productsRequested.value = newVal?.funding_products_requested || [];
  },
  { immediate: true, deep: true }
);

onMounted(getWflOfferTemplates);
</script>
